export const BASIC_LAYOUT = 8;
export const VERTICAL_LAYOUT = 4;
//# sourceMappingURL=videos-per-page-count.js.map